export default "__VITE_ASSET__BtbEGIS2__"